import type { UniclientCheckoutProps } from './components/checkout';
import type { UniclientPageFrame } from './frame';
import type { PaymentPlan } from './payment';
import type { UniclientStepPresentation } from './step';

type CheckoutProps<TComponentAttributes extends string> = Omit<UniclientCheckoutProps<TComponentAttributes>, 'type'> &
  Omit<UniclientPageFrame, 'action' | 'lockHistory' | 'progress' | 'summary' | 'type'> &
  Omit<UniclientStepPresentation<TComponentAttributes>, 'component' | 'frame' | 'type'>;

export function checkout<TComponentAttributes extends string>({
  title,
  header = {},
  ...restProps
}: CheckoutProps<TComponentAttributes>): UniclientStepPresentation<TComponentAttributes> {
  return {
    frame: {
      type: 'page',
      title,
      header,
      lockHistory: false,
    },
    component: {
      type: 'checkout',
      ...restProps,
    },
  };
}

export function checkoutPlan(props: Omit<PaymentPlan, 'presentation'>): PaymentPlan {
  return { ...props, presentation: 'labels' };
}
